/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function QuoteIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="quote"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M18.75 12.5L18.75 6.5C18.75 5.395 17.855 4.5 16.75 4.5L15.25 4.5C14.145 4.5 13.25 5.395 13.25 6.5L13.25 10.75C13.25 11.716 14.034 12.5 15 12.5C15.966 12.5 16.75 13.284 16.75 14.25L16.75 16C16.75 16.828 16.078 17.5 15.25 17.5L14.75 17.5C14.198 17.5 13.75 17.948 13.75 18.5C13.75 19.052 14.198 19.5 14.75 19.5L16.75 19.5C17.855 19.5 18.75 18.605 18.75 17.5L18.75 12.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.75 12.5L10.75 6.5C10.75 5.395 9.855 4.5 8.75 4.5L7.25 4.5C6.145 4.5 5.25 5.395 5.25 6.5L5.25 10.75C5.25 11.716 6.034 12.5 7 12.5C7.966 12.5 8.75 13.284 8.75 14.25L8.75 16C8.75 16.828 8.078 17.5 7.25 17.5L6.75 17.5C6.198 17.5 5.75 17.948 5.75 18.5C5.75 19.052 6.198 19.5 6.75 19.5L8.75 19.5C9.855 19.5 10.75 18.605 10.75 17.5L10.75 12.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
